<template>
  <div class="orgn">
    <div class="orgn-detail" v-if="orgnDetail.id">
      <h1 class="orgn-detail-title">
        <span>{{ orgnDetail.fullname }} </span>
        <ghidri-back/>
      </h1>

      <div class="orgn-detail-block">
        <div>{{ orgnDetail.introduction }}</div>
      </div>

      <div class="orgn-detail-block">
        <p class="orgn-detail-description" v-html="orgnDetail.detail"></p>
      </div>
    </div>

    <div class="orgn-detail" v-else>
      <ghidri-empty>
        <span>暂无数据</span>
        <el-button icon="el-icon-back" type="text" @click="backEvent">点击返回</el-button>
      </ghidri-empty>
    </div>

    <el-backtop :bottom="100"></el-backtop>
  </div>
</template>

<script>
  import { getDept } from "@/api/system/dept.js";

  const baseApi = process.env.VUE_APP_BASE_API;

  export default {
    name: "OrgnDetail",
    data() {
      return {
        orgnDetail: {}
      };
    },
    created() {
      const id = this.$route.params.id;
      this.init(id);
    },
    methods: {
      init(id) {
        const _this = this;
        if (id != null && typeof (id) != "undefined" && id != "") {
          let loading = _this.$loading({ position: { top: 60 } });
          getDept(id).then(res => {
            if (res.success) {
              const data = res.data;
              if (data && data.pic) {
                data.img = baseApi + "/file/getImgStream?fileId=" + data.pic;
              }

              const thumb = new Array();
              if (data && data.gallery) {
                const gallery = data.gallery.split(",");
                for (var index in gallery) {
                  thumb.push(baseApi + "/file/getImgStream?fileId=" + gallery[index]);
                }
                data.thumb = thumb;
              }

              _this.orgnDetail = data;
            }
            loading.close();
          }).catch(loading.close);
        }
      },

      //返回
      backEvent() {
        this.$router.go(-1);
      }
    }
  };
</script>

<style lang="less" scoped>
  .orgn {
    min-height: calc(100vh - 400px);
    display: flex;
    justify-content: center;
    align-items: center;

    .orgn-detail {
      width: 900px;

      margin: auto;
      margin-top: 30px;
      line-height: 2em;

      background: #fff;
      box-shadow: 0px 9px 20px 0px #c2c1c180;
      border-radius: 10px;
      padding: 30px;

      &-block {
        margin: 40px 0;
      }
    }
  }
</style>
